// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"2397e028","120":"2397e028"}[chunkId] + ".chunk.css";
};